import React, { useState } from 'react';
import Header from '../components/Header';
import HeroSection from '../components/HeroSection';
import PainPoints from '../components/PainPoints';
import Services from '../components/Services';
import Solutions from '../components/Solutions';
import TechnologyCapabilities from '../components/TechnologyCapabilities';
import Approach from '../components/Approach';
import AboutMe from '../components/AboutMe';
import BlogsResources from '../components/BlogsResources';
import FAQs from '../components/FAQs';
import ContactSection from '../components/ContactSection';
import Footer from '../components/Footer';

const Home = () => {
  const [activeService, setActiveService] = useState(() => window.innerWidth > 768 ? 'everyday-digital' : null);

  return (
    <div className="home-page">
      <Header />
      <HeroSection />
      <PainPoints />
      <Approach />
      <Services onServiceSelect={setActiveService} activeService={activeService} />
      <Solutions activeGroup={activeService} />
      <TechnologyCapabilities />
      <AboutMe />
      <BlogsResources />
      <FAQs />
      <ContactSection />
      <Footer />
    </div>
  );
};

export default Home;
